export enum ROLES {
  ADMIN = 'admin-users',
}

export enum ERROR_CODES {
  USER_EXISTS = '409U',
  EMAIL_EXISTS = '409E',
  DNI_EXISTS = '409D',
}

export const ERROR_MESSAGES = {
  USER_EXISTS: { status: 409, code: ERROR_CODES.USER_EXISTS },
  EMAIL_EXISTS: { status: 409, code: ERROR_CODES.EMAIL_EXISTS },
  DNI_EXISTS: { status: 409, code: ERROR_CODES.DNI_EXISTS },
};
